import type { UploadOutcome } from '~/hooks/use-upload-with-progress'

const REFUSALS: Record<string, string> = {
  DOCUMENT_NOT_PDF: 'documents.error.notPdf',
  DOCUMENT_TOO_LARGE: 'documents.error.tooLarge',
  DOCUMENT_LIMIT_REACHED: 'documents.error.limit',
  DOCUMENT_FILE_REQUIRED: 'documents.error.noFile',
  TITLE_REQUIRED: 'documents.error.noTitle',
}

/** Ce que l'écran dit d'un dépôt raté (#326), en clé i18n ; null s'il a réussi ou a été annulé. */
export function documentUploadError(outcome: UploadOutcome): string | null {
  if (outcome.kind === 'cancelled') return null
  if (outcome.kind === 'networkError') return 'documents.error.network'
  const { status, body } = outcome.response
  if (status >= 200 && status < 300) return null
  if (status === 413) return 'documents.error.tooLarge'
  const message = typeof body === 'object' && body !== null ? (body as { message?: unknown }).message : null
  return (typeof message === 'string' && REFUSALS[message]) || 'documents.error.unknown'
}
